import {
  transformToCamelCase,
  transformToSnakeCase,
} from '@carboncopyco/utils';
import type { BaseQueryApi } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';

const caseTransformationIgnoreList = [
  (payload: any): boolean =>
    payload[0] && payload[0].type === 4 && payload[0].data.href,
];

type CustomFetchArgs = {
  noFormatBody?: Record<string, any>;
  rawBody?: FetchArgs['body'];
};

export const baseQueryCasing =
  <
    Args extends FetchArgs,
    Result,
    Error = FetchBaseQueryError,
    DefinitionExtraOptions = Record<string, unknown>,
    Meta = Record<string, unknown>,
  >(
    baseQuery: BaseQueryFn<Args, Result, Error, DefinitionExtraOptions, Meta>
  ): BaseQueryFn<Args, Result, Error, DefinitionExtraOptions, Meta> =>
  (
    fetchArgs: Args & CustomFetchArgs,
    api: BaseQueryApi,
    extraOptions: DefinitionExtraOptions
  ) => {
    if (typeof fetchArgs !== 'string') {
      if (fetchArgs.params) {
        fetchArgs.params = transformToSnakeCase(fetchArgs.params);
      }
      if (fetchArgs.body) {
        fetchArgs.body = transformToSnakeCase(fetchArgs.body);
      }

      if (fetchArgs.noFormatBody) {
        Object.assign(fetchArgs.body, fetchArgs.noFormatBody);
      }

      if (fetchArgs.rawBody) {
        const { rawBody, ...restFetchArgs } = fetchArgs;
        fetchArgs = {
          ...restFetchArgs,
          body: rawBody,
        } as Args & CustomFetchArgs;
      }
    }

    return baseQuery(
      {
        responseHandler: async (response) => {
          const json = await response.json();
          return transformToCamelCase(json, caseTransformationIgnoreList);
        },
        ...fetchArgs,
      },
      api,
      extraOptions
    );
  };
